import { Field } from 'formik'
import IMask from 'imask'
import React, { PureComponent } from 'react'
import HigherOrderField from './higher-order-field.component'
import debounce from '../../helpers/debounce.helper'

class BaseMaskedInput extends PureComponent {
	constructor(props) {
		super(props)
		const { elementRef } = this.props
		this.elementRef = elementRef || React.createRef()
		this.state = {
			value: ''
		}
	}

	componentDidMount() {
		const { mask, id, value: formikValue, dispatch } = this.props
		this.mask = new IMask(document.getElementById(id), { mask, dispatch })
		this.maskValue((formikValue || '').toString())
	}

	componentWillReceiveProps(nextProps) {
		const { value: currentValue } = this.state
		const { value: formikValue } = nextProps
		if (formikValue != this.unmaskValue(currentValue))
			this.maskValue(formikValue || '')
	}

	handleChange = event => {
		const value = event.target.value
		this.resolve(value)
	}

	handleBlur = () => {
		const { id, onBlur } = this.props
		onBlur(id, true)
	}

	resolve = value => {
		const { id, onChange, onChangeHandler, onComplete } = this.props

		this.setState({ value }, () =>
			debounce(
				300,
				() => {
					const unmaskedValue = this.unmaskValue(value)
					onChange(id, unmaskedValue)
					onChangeHandler && onChangeHandler(unmaskedValue)
					if (this.mask.masked.isComplete)
						onComplete && onComplete(unmaskedValue)
				},
				'baseMasked'
			)
		)
	}

	maskValue = value => {
		this.mask.masked.resolve(value)

		const maskedValue = this.mask.masked.value

		this.resolve(maskedValue)
		this.mask.value = maskedValue
	}

	unmaskValue = value => {
		const { mask } = this.props
		this.mask.masked.resolve(value)
		const unmaskedValue = this.mask.masked.unmaskedValue
		if (mask == '00/00/0000') {
			const day = unmaskedValue.substr(0, 2)
			const month = unmaskedValue.substr(2, 2)
			const year = unmaskedValue.substr(4, 4)
			const fulldate = `${year}-${month}-${day}`

			return this.mask.masked.isComplete ? fulldate : value
		} else return this.mask.masked ? unmaskedValue : value
	}

	render() {
		const {
			id,
			type,
			style,
			disabled,
			autoFocus,
			maxLength,
			placeholder,
			toClean
		} = this.props
		const { value } = this.state

		if (toClean) {
			this.resolve("")
		}

		return (
			<HigherOrderField innerRef={this.elementRef} {...this.props}>
				<Field
					id={id}
					name={id}
					type={type}
					style={style}
					autoCorrect="nope"
					autoComplete="nope"
					value={value || ''}
					disabled={disabled}
					autoFocus={autoFocus}
					maxLength={maxLength}
					onBlur={this.handleBlur}
					placeholder={placeholder}
					innerRef={this.elementRef}
					onInput={this.handleChange}
				/>
			</HigherOrderField>
		)
	}
}

export default BaseMaskedInput
